import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'wouter';
import SingleBlog from '../components/SingleBlog';
import Navbar from '../components/Navbar';
import Layout from './Layout';
import Footer from '../components/Footer';
import Loading from '../components/Loading';
import { getApartmentBySlug, getSite } from '../tools/fetcher';

export default function Apartment() {
    const { isPending, isError } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    const [data, setData] = useState(null);
    const [location] = useLocation();

    useEffect(() => {
        if (location.includes('/apartment/')) {
            const slug = location.split('/apartment/')[1];
            getApartmentBySlug(slug).then((resp) => {
                if (resp.length) {
                    setData(resp[0]);
                }
            });
        } else {
            setData(null);
        }
    }, [location]);

    if (isPending) {
        return <Loading />;
    }
    if (isError) {
        return <Loading>Error loading data</Loading>;
    }

    return (
        <Layout className="min-w-[360px] font-dm-sans text-apart-black-100">
            <div className="px-4 sm:px-6 lg:px-8 xl:px-[140px] sm:pt-6 bg-apart-white-50 sm:pb-6">
                <Navbar showMenu={false} className={'max-w-[1160px] mx-auto'} />
            </div>
            <div className="px-4 py-[60px] sm:px-6 lg:px-8 xl:px-[140px] sm:pt-[80px] sm:py-[120px] bg-white">
                {data && (
                    <SingleBlog
                        data={data}
                        className={'max-w-[1160px] mx-auto'}
                    />
                )}
            </div>
            <div
                id="footer"
                className="px-4 py-[60px] sm:px-6 lg:px-8 xl:px-[140px] sm:py-[120px] sm:pt-[60px] bg-apart-white-50"
            >
                <Footer className={'max-w-[1160px] mx-auto'} />
            </div>
        </Layout>
    );
}
